import { render, staticRenderFns } from "./IconCheckbox.vue?vue&type=template&id=3d4cd352"
import script from "./IconCheckbox.vue?vue&type=script&lang=js"
export * from "./IconCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports